export type SiteRoute =
  | "/"
  | "/despre-noi"
  | "/stiinta-vindecarii-germanice"
  | "/personocratia"
  | "/ateliere"
  | "/articole"
  | "/testimoniale"
  | "/contact"
  | "/politica-de-confidentialitate";

export function routeHref(route: SiteRoute): string {
  return route === "/" ? "/" : `${route}/`;
}

export function articleHref(slug: string): string {
  return `/articole/${encodeURIComponent(slug)}/`;
}
